import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "EnsureSharedMailboxData"*/ './ensureSharedMailboxData')
);

export const lazyEnsureSharedMailboxData = new LazyAction(
    lazyModule,
    m => m.ensureSharedMailboxData
);

/**
 * Ensures that shared mailboxes are initialized for the specified sourceId
 * @param sourceId source for which mailboxes are to be loaded
 * @returns Promise that will complete when the mailboxes are complete
 */
export default async function initializeSharedMailboxes(sourceId: string): Promise<void> {
    // not all modules need the ability to load the shared mailboxes, so we lazy load the
    // functionality for making sure the shared mailbox module is loaded
    return lazyEnsureSharedMailboxData.importAndExecute(sourceId);
}
